import {
  useLookupAccountForImpersonationQuery,
  type LookupAccountForImpersonationQuery,
  type LookupAccountForImpersonationQueryVariables,
} from '../../__codegen__/api'

/**
 * Hook to look up an enterprise account by email or canonical ID for impersonation purposes.
 *
 * @returns The query hook from Apollo Client
 */
export const useLookupAccountForImpersonation = useLookupAccountForImpersonationQuery

export type { LookupAccountForImpersonationQuery, LookupAccountForImpersonationQueryVariables }
